module.exports = __webpack_public_path__ + "static/media/logo-img@2x.a3ab6975.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo-img@2x.png
// module id = 77
// module chunks = 0